module.exports = " <div> <section class=page-section> <h2>Team</h2> <p>Thank you for playing Send Unicorn! </p> </section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/About.vue
// module id = 141
// module chunks = 0